import React from 'react';
import { GenericDetailPage } from '../../components/generic';
import { useExpenseCategory, ExpenseCategory } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';
import SubcategoriesSection from './SubcategoriesSection';

const Detail: React.FC = () => {
  const getDetailSectionsWithSubcategories = (
    item: ExpenseCategory,
    formatDate: (dateString?: string) => string
  ) => getDetailSections(item, formatDate, <SubcategoriesSection categoryId={item.id} />);

  return (
    <GenericDetailPage<ExpenseCategory>
      useData={useExpenseCategory}
      config={{
        ...moduleConfig,
        getDetailSections: getDetailSectionsWithSubcategories,
        getStatusBadges,
      }}
    />
  );
};

export default Detail;
